"use client";

import Link from "next/link";
import { ArrowRight, Clock3, Heart } from "lucide-react";
import { DogCard } from "@/components/DogCard";
import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";
import { useCatalogDogs } from "@/features/marketplace/useCatalogDogs";
import { useAppStore } from "@/store/useAppStore";

export function DogCollection({ type }: { type: "favorites" | "recent" }) {
  const dogs = useCatalogDogs();
  const ids = useAppStore((state) =>
    type === "favorites" ? state.favorites : state.recentDogs,
  );
  const clear = useAppStore((state) =>
    type === "favorites" ? state.clearFavorites : state.clearRecentDogs,
  );
  const items = ids
    .map((id) => dogs.find((dog) => dog.id === id))
    .filter((dog): dog is (typeof dogs)[number] => Boolean(dog));
  const isFavorites = type === "favorites";
  return (
    <main>
      <SiteHeader compact />
      <section className="collection-hero">
        <div className="shell">
          <span className="eyebrow">
            {isFavorites ? "MY FAVORITES" : "RECENTLY VIEWED"}
          </span>
          <h1>{isFavorites ? "마음에 담아둔 친구들" : "최근 살펴본 친구들"}</h1>
          <p>
            {isFavorites
              ? "서두르지 말고 성격과 환경, 건강 정보를 다시 비교해보세요."
              : "최근 본 순서대로 최대 12마리까지 이 기기에 저장됩니다."}
          </p>
        </div>
      </section>
      <section className="collection-body shell">
        <div className="collection-top">
          <b>{items.length}마리</b>
          {items.length > 0 && (
            <button type="button" onClick={clear}>
              목록 비우기
            </button>
          )}
        </div>
        {items.length > 0 ? (
          <div className="dog-grid">
            {items.map((dog) => (
              <DogCard dog={dog} key={dog.id} />
            ))}
          </div>
        ) : (
          <div className="collection-empty">
            {isFavorites ? <Heart /> : <Clock3 />}
            <h2>
              {isFavorites
                ? "아직 찜한 친구가 없어요"
                : "아직 살펴본 친구가 없어요"}
            </h2>
            <p>
              {isFavorites
                ? "궁금한 친구의 하트 버튼을 눌러 천천히 다시 살펴보세요."
                : "친구의 상세 페이지를 보면 이곳에서 다시 만날 수 있어요."}
            </p>
            <Link href="/dogs">
              친구 찾아보기 <ArrowRight />
            </Link>
          </div>
        )}
      </section>
      <SiteFooter />
    </main>
  );
}
